module.exports = __webpack_public_path__ + "img/gpx_preview.ec12405.png";